// TODO: Copied from LMV for now. Should simply be consumed via import after switching to LMV.
export const MeshFlags = Object.freeze({
  // FragmentList flags
  //visibility/highlight bitmask flags

  //Byte 0

  //NOTE: This is confusing and it should be fixed, but when the MESH_VISIBLE bit is off, the mesh
  //will draw in ghosted mode. To completely skip drawing a mesh, set the HIDE flag.
  MESH_VISIBLE: 1,
  MESH_HIGHLIGHTED: 2,
  MESH_HIDE: 4, // The mesh is not rendered at all
  MESH_ISLINE: 8,
  MESH_MOVED: 0x10, // indicates if an animation matrix is set
  MESH_RENDERFLAG: 0x20,
  MESH_NOTLOADED: 0x40, // the fragment's geometry hasn't been loaded (or was unloaded) and there's no intention to load it. (e.g. selective loading)
  MESH_ISPOINT: 0x80, // indicates that the mesh is vertex-only

  //Byte 1
  //TODO: Two bits are enough to hold ISLINE, ISWIDELINE and ISPOINT, we don't need to waste three,
  //but there is no point to optimizing this as long as the required flags go over one byte.
  MESH_ISWIDELINE: 0x100, // indicates that the mesh is wide line
  MESH_TRAVERSED: 0x200, // only used for paging: drawn fragments are tagged and then skipped by forEach() until the flag is being reset (e.g. on scene/camera changes)
  MESH_DRAWN: 0x400, // only used for paging: drawn fragments are tagged. At the end of all render passes flag is copied to MESH_TRAVERSED.
  // The fragment is intended for custom tools, e.g. room geometry.
  // However they are in fact rendered (initially ghosted) and can be made opaque e.g. by "show all" (LMV-6230).
  MESH_NOT_FOR_DISPLAY: 0x800,
  MESH_CONSOLIDATED: 0x1000, // The fragment is part of a consolidated mesh
  MESH_INSTANCED: 0x2000 // The fragment is part of an instanced mesh. This conflicts with RENDER_SHADOWMAP flag in RenderBatchML, but incremental consolidation and memory limited extension are mutually exclusive.
  // The Memory Limited Extension uses the high order three bits of this byte
});